import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoadingBarModule, LoadingBarService } from '@ngx-loading-bar/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MailDocumentComponent } from '../account/support-components/mail-document/mail-document.component';
import { FunctionCalendarDialogComponent } from '../accountFunction/calendar-function/function-calendar-dialog.component';
import {
  FunctionSalesActivityDialogComponent
} from '../accountFunction/function-sales-activity/function-sales-activity-dialog.component';
import { GroupSalesActivityComponent } from '../accountGroup/group-add-edit/group-sales-activity.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { AdminLayoutComponent, HeaderComponent, MenuComponent, SidebarComponent } from '../core';
import { NotificationComponent } from '../core/notification/notification.component';
import { SwitchPropertyComponent } from '../core/switch-property/switch-property.component';
import { AskQuestionComponent } from '../core/tech-support/ask-question/ask-question.component';
import { ReportIssueComponent } from '../core/tech-support/report-issue/report-issue.component';
import { SuggestEnhancementComponent } from '../core/tech-support/suggest-enhancement/suggest-enhancement.component';
import { MailComponent } from '../mail/mail.component';
import { SalesActivityAddEditComponent } from '../sales-activity/sales-activity-add-edit/sales-activity-add-edit.component';
import { AccountService } from '../services/account.service';
import { AccountsService } from '../services/accounts.service';
import { CalendarService } from '../services/calendar.service';
import { SalesActivityService } from '../services/sales-activity.service';
import { NotesService } from '../services/shared/notes.service';
import { TokenInterceptor } from '../services/shared/token.interceptor';
import { TechService } from '../services/tech.service';
import { ContractsComponent } from '../shared-components/contracts/contracts.component';
import { FilterDialogModalComponent } from '../shared-components/filter-dialog-modal/filter-dialog-modal.component';
import { ShowGradeComponent } from '../shared-components/show-grade/show-grade.component';
import { FilterPipe } from './filter.pipe';
import { SafePipe } from './safe.pipe';
import { TimeFormat } from './timepipe.pipe';

const sharedComponents = [
  GroupSalesActivityComponent,
  FunctionSalesActivityDialogComponent,
  SwitchPropertyComponent,
  ShowGradeComponent,
  FilterDialogModalComponent,
  FunctionCalendarDialogComponent,
  MailComponent
];

const commonModules = [
  CommonModule,
  FormsModule,
  FlexLayoutModule,
  ReactiveFormsModule,
  AppMaterialModule,
  NgxMatSelectSearchModule,
  TextMaskModule,
  EditorModule
];
@NgModule({
  imports: [
    RouterModule,
    LoadingBarModule,
    PerfectScrollbarModule,
    ...commonModules
  ],
  declarations: [
    SalesActivityAddEditComponent,
    AdminLayoutComponent,
    HeaderComponent,
    NotificationComponent,
    ReportIssueComponent,
    SuggestEnhancementComponent,
    AskQuestionComponent,
    SidebarComponent,
    MenuComponent,
    MailDocumentComponent,
    SafePipe,
    TimeFormat,
    FilterPipe,
    ContractsComponent,
    ...sharedComponents
  ],
  exports: [
    MailDocumentComponent,
    SafePipe,
    FilterPipe,
    TimeFormat,
    ...commonModules,
    ContractsComponent
  ],
  providers: [LoadingBarService, CalendarService, NotesService, TechService, AccountService, SalesActivityService,
    AccountsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }],
  entryComponents: [...sharedComponents]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts